/*  ==========================================================================
    DYNFORMS GET-PARAMS
    ========================================================================== */

/*
 * IMPORTS
 */

import {getAllUrlParams} from '../../../utilities/lib/general';
// all params
const urlParams = getAllUrlParams(window.location.href);


// room_code|
const getRoomCodes = () => {
    const roomCode = urlParams['room_code'];
    const lastMinuteCode = urlParams['lastminute_code'];

    if (lastMinuteCode) {
        return lastMinuteCode.split(',');
    }
    else {
        if (roomCode) {
            return roomCode.split(',');
        }
    }
    return undefined;
};

export const params = {
    fromdate: urlParams['fromdate'] || undefined,
    todate: urlParams['todate'] || undefined,
    offer: urlParams['offer_id'] || undefined,
    roomcodes: getRoomCodes(),
    lastminute_code: !!urlParams['lastminute_code']
};



// WEBPACK FOOTER //
// ./source/js/ehotelier/dynforms/params/params.js